import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent implements OnInit {
  currentYear: string = '';
  isMobile: boolean = false;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear().toString();

    setTimeout(() => {
      let platform = localStorage.getItem('platform');

      if (platform !== 'indosat') {
        this.isMobile = true;
      }
    }, 500);
  }

}
